<template>
  <div class="app-main-content">
    <div class="details-view">
      <div style="height: 100%">
        <div style="display: flex;flex-wrap: nowrap;height: 100%;">
          <div class="section" style="width: 25%; background-color: #ffffff">
            <div style="">
              <span
                style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{ '.' }}</span>
              <div style="padding-left: 10px;padding-bottom: 15px"> {{ $t('CargoMsg.Cargo_TransmissionRule') }}</div>
            </div>
            <!--            <div style="height: 50%;">-->
            <!--              <el-form-->
            <!--                label-position="left"-->
            <!--                label-width="0px"-->
            <!--                style="height: 100%"-->
            <!--              >-->
            <!--                <el-form-item label=" " style="height: 100%" class="input-from">-->
            <!--                  <el-input-->
            <!--                    v-model="ruleData"-->
            <!--                    class="input-border"-->
            <!--                    :filter-chars="false"-->
            <!--                    type="textarea"-->
            <!--                    :readonly="true"-->
            <!--                    clearable-->
            <!--                  />-->
            <!--                </el-form-item>-->
            <!--              </el-form>-->
            <!--            </div>-->
            <div style="display: flex;padding-top: 5px;padding-bottom: 5px;justify-content: space-between;">
              <div style="display: flex; align-items: center;">
                <span
                  style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
                >{{ '.' }}</span>
                <div style="padding-left: 10px; display: flex;">
                  {{ $t('CargoMsg.Cargo_AccountPassword') }}
                </div>
              </div>
            </div>
            <div style="height: 50%; margin-top: 12px;">
              <el-form
                label-position="left"
                label-width="100px"
                style="height: 100%"
              >
                <el-form-item label="cusId:">
                  <el-input v-model="nbParams.id" no="id" style="width: 300px" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_InterfaceUrl') + ':'">
                  <el-input v-model="nbParams.interfaceUrl" no="taskName" style="width: 300px" />
                </el-form-item>
                <el-form-item label="API_KEY:">
                  <el-input v-model="nbParams.action" no="action" style="width: 300px" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="section" style="width: 35%;background-color: #ffffff">
            <div style="display: flex;justify-content: space-between;">
              <div>
                <span
                  style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
                >{{ '.' }}</span>
                <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_Script') }} </div>
              </div>
              <div style="padding: 1px">
                <el-button type="success" @click="deBugHandler">{{ $t('CargoMsg.Cargo_DebuggingResults') }}</el-button>
              </div>
            </div>
            <div style="display: flex;height: 100%;">
              <div style="height: 100%;width: 100%">
                <el-form
                  label-position="left"
                  label-width="0px"
                  style="height: 100%"
                >
                  <el-form-item label=" " style="height: 100%" class="input-from">
                    <el-input
                      v-model="nbParams.dataScript"
                      class="input-border"
                      :filter-chars="false"
                      type="textarea"
                      clearable
                    />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="section" style="width: 40%; background-color: #ffffff">
            <div style="">
              <span
                style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{ '.' }}</span>
              <div style="padding-left: 10px;padding-bottom: 15px"> {{ $t('CargoMsg.Cargo_TransmissionSample') }}</div>
            </div>
            <div style="height: 100%;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <el-form-item label=" " style="height: 100%" class="input-from">
                  <el-input
                    v-model="dataMessage"
                    :disabled="!isPlatform"
                    class="input-border"
                    :readonly="true"
                    :placeholder="contentTip"
                    :filter-chars="false"
                    type="textarea"
                    clearable
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <show-message-dialog
      v-if="showMessage.visible"
      :visible.sync="showMessage.visible"
      :message-text="showMessage.messageText"
    />
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { pushShippingExchangeDeBugFunc } from '@/api/clearing/invoice'
import showMessageDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog.vue'
import { pushMlsDataDeBugFunc } from '@/api/booking/job'

export default {
  name: 'MlsSendSetting',
  components: { showMessageDialog },
  props: {
    taskScenario: { type: String, required: true }
  },
  data() {
    return {
      SystemConstants,
      querySql: '',
      showMessage: {
        visible: false,
        messageText: ''
      },
      nbParams: {
        accountId: '',
        passWord: '',
        id: '',
        tokenUrl: '',
        interfaceUrl: '',
        action: '',
        dataScript: ''
      },
      dataMessage: ''
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    },
    isPlatform() {
      return this.$store.getters.isPlatform
    },
    ruleData() {
      if (this.taskScenario === SystemConstants.TASK_SCENARIO_3.code) {
        return 'status中过滤出状态变更时间>上一次发送的时间的状态'
      } else if (this.taskScenario === SystemConstants.TASK_SCENARIO_4.code) {
        return ''
      } else if (this.taskScenario === SystemConstants.TASK_SCENARIO_5.code) {
        return '费用名称=代理国际海运费、代理空运费  type传输：“freight_fee”\n' +
          '费用名称= 提货费   type传输“pickup_fee”\n' +
          '费用名称=税金    type传输“tax_fee”\n' +
          '费用名称=堆存费    type传输“storage_fee”\n' +
          '费用名称=操作费    type传输“operate_fee”\n' +
          '费用名称=商检服务费    type传输“servicez-fee”\n' +
          '其他费用名称，type传输“petty_fee”'
      }
      return ''
    },
    contentTip() {
      if (this.taskScenario === SystemConstants.TASK_SCENARIO_3.code) {
        return '{\n' +
          '\t"cusId":"PYK_1234",\n' +
          '\t"time":"2025-10-09 13:23:67",\n' +
          '\t"po": "Test1009",\n' +
          '\t"status": "loading_success",\n' +
          '\t"change_time": "2025-10-09 14:47:43",\n' +
          '\t"sign": "FCB34A315AC566B7602F10554CAA1569"\n' +
          '}'
      } else if (this.taskScenario === SystemConstants.TASK_SCENARIO_4.code) {
        return '{\n' +
          '\t"cusId":"PYK_1234",\n' +
          '\t"time":"2025-10-09 13:23:45",\n' +
          '\t"po": "Test1009",\n' +
          '\t"pickup_address":"Carolina Printing 618 South 5th st Hartsville, SC 29550",\n' +
          '\t"product_detail":"[{"po":"Test1009","product_name":"5QT Stock Pot with lid - Sage","shipping_mark":"MODEL NUMBER: LC-5STOCK-SG-AO\\nITEM DESCRIPTION: 5QT Stock Pot with lid - Sage\\nPI NUMBER: 39278\\nNET WEIGHT: 7.5 kg\\nGROSS WEIGHT: 8.9 kg\\nCARTON DIMENSIONS: 52x35.5x40 (cm)\\nQUANTITY/CTN: 6 sets\\nCTN NO: / 300\\nUPC: 089902975104\\nCOUNTRY OF ORIGIN: China","tracking_number":"SELU4353305","pickup_number":"MLSSE25090038A","quantity":30,"gw":653.2,"pallet_count":2,"pallet_detail": "[\"1p*24\",\"1p*6\"]","pallet_size":"48*40*70","pallet_img":"https://erXXX.com/21we32f27b.png"}]",\n' +
          '\t"sign": "20B8838BF02C33280A6370148DDD6030"\n' +
          '}'
      } else if (this.taskScenario === SystemConstants.TASK_SCENARIO_5.code) {
        return '{\n' +
          '\t"cusId":"PYK_1234",\n' +
          '\t"time":"2025-10-09 13:23:45",\n' +
          '\t"po": "Test1009",\n' +
          '\t"rmb_amount":3,\n' +
          '\t"rmb_detail":"[{"amount":1,"type":"freight_fee","currency":"RMB","remark":"运费"},{"amount":2,"type":"petty_fee","currency":"RMB","remark":"其他费⽤"}]",\n' +
          '\t"usd_amount":30,\n' +
          '\t"usd_detail":"[{"amount":10,"type":"storage_fee","currency":"USD","remark":"仓储费"},{"amount":20,"type":"pickup_fee","currency":"USD","remark":"提货费"}]",\n' +
          '\t"sign": "3BE9D9C4D5E79B9F80D383226A8772F6"\n' +
          '}'
      }
      return ''
    }
  },
  beforeMount() {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    async onShow(action, from, task) {
      await this.clearParams()
      if (task) {
        if (task.propertiesData && Object.keys(task.propertiesData).length) {
          this.loadProperties(task.propertiesData)
        }
        this.querySql = task.dataScript
      }
    },
    async clearParams() {
      this.nbParams.accountId = ''
      this.nbParams.passWord = ''
      this.nbParams.id = ''
      this.nbParams.tokenUrl = ''
      this.nbParams.interfaceUrl = ''
      this.nbParams.action = ''
      this.nbParams.dataScript = ''
    },
    loadProperties(item) {
      this.nbParams.accountId = item.accountId
      this.nbParams.passWord = item.passWord
      this.nbParams.id = item.id
      this.nbParams.tokenUrl = item.tokenUrl
      this.nbParams.interfaceUrl = item.interfaceUrl
      this.nbParams.action = item.action
      this.nbParams.dataScript = item.dataScript
    },
    deBugHandler() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyStr: this.querySql,
        anyStr1: this.nbParams.dataScript,
        anyStr2: this.taskScenario
      }
      pushMlsDataDeBugFunc(params).then(res => {
        this.showMessage.messageText = res.data
        this.showMessage.visible = true
      })
    },
    endTabHandler() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    },
    toNext() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    }
  }
}
</script>
<style lang="scss">
.app-main-content {

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 100%;
    }
  }

  .input-border {
    height: 100%;

    .el-textarea__inner {
      width: 100%;
      height: 100%;
    }
  }

  .general-pagination {
    .el-pager {
      li.number.active {
        color: blue !important;
      }
    }
  }
}
</style>
